import { render, staticRenderFns } from "./content-alignment.vue?vue&type=template&id=626451c4&"
import script from "./content-alignment.vue?vue&type=script&lang=js&"
export * from "./content-alignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports